import { useParams } from '@tanstack/react-router';
import { PurchaseOrderDocuments } from '@/features/purchase-order/purchase-order-documents';

export function PurchaseOrderDocumentsPage() {
  const { id } = useParams({ strict: false });

  return <PurchaseOrderDocuments purchaseOrderId={`${id}`} />;
}
